import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useSelector } from "react-redux";
import {
  isFavorite,
  showFeatureDetails,
  showFeature,
  copyFeature,
} from "../../lib/featureUtils";
import { getProjectionCode, key, trans } from "../../lib/utils";
import store from "../../stores/store";
import moment from "moment/moment";
import Loader from "../loader/loader";
import Editors from "../editors/editors";
import DownloadFeatures from "./downloadFeatures";
import FeaturesChart from "./featuresChart";

function FeaturesTable(props) {
  const favoriteIds = useSelector(
    (state) => store.getState().results.favoriteResultsFeatureIds
  );

  const layers = useSelector((state) => store.getState().layers);

  const [data, setData] = useState([]);

  useEffect(() => {
    window["recaclulatePerfectScrollbarHeight"]();
  }, [favoriteIds]);

  function attributesToBootstrapTableColumns(attributes) {
    let defaultAttributes = [
      {
        dataField: "_featureId",
        text: "",
        hidden: true,
      },
      {
        dataField: "_feature",
        text: "",
        hidden: true,
      },
      {
        dataField: "_toggleFavorites",
        text: "",
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center" };
        },
        hidden: props.controls
          ? props.controls.indexOf("favorites") < 0
            ? true
            : false
          : false,
        formatter: function (cell, row) {
          let className = row._isFavorite
            ? "fas fa-star m-auto"
            : "far fa-star m-auto";

          return (
            <i
              className={className}
              key={key()}
              role="button"
              onClick={(e) => {
                store.dispatch({
                  type: "results/favoriteResults/toggle",
                  payload: { id: props.layerId, data: row },
                });
              }}
            ></i>
          );
        },
      },
      {
        dataField: "_zoomToFeature",
        text: "",
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center" };
        },
        formatter: function (cell, row) {
          return (
            <i
              className="fas fa-compress  m-auto"
              role="button"
              onClick={(e) => {
                let feature = row._feature ? JSON.parse(row._feature) : {};

                feature.projection = getProjectionCode(row._srsName);
                feature.url = row._featureUrl;
                showFeature(feature);
              }}
            ></i>
          );
        },
      },
      {
        dataField: "_showFeatureInfo",
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center" };
        },
        hidden: props.controls
          ? props.controls.indexOf("info") < 0
            ? true
            : false
          : false,
        formatter: function (cell, row) {
          return (
            <i
              className="fas fa-info-circle  m-auto"
              role="button"
              onClick={(e) => {
                let feature = row._feature ? JSON.parse(row._feature) : {};
                feature.projection = row._srsName;
                feature.url = row._featureUrl;
                feature.layerId = props.layerId;
                showFeatureDetails(feature);
              }}
            ></i>
          );
        },
        text: "",
      },
      {
        dataField: "_copyFeature",
        text: "",
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center" };
        },
        formatter: function (cell, row) {
          return (
            <i
              className="far fa-copy  m-auto"
              title="Copy feature"
              role="button"
              onClick={(e) => {
                let feature = row._feature ? JSON.parse(row._feature) : {};

                feature.projection = getProjectionCode(row._srsName);
                feature.url = row._featureUrl;

                copyFeature(
                  feature,
                  store,
                  layers[props.layerId].name,
                  layers[props.layerId].title
                );
              }}
            ></i>
          );
        },
      },
    ];

    attributes.forEach((attribute) => {
      if (attribute.visible) {
        if (attribute.name !== "_featureId" && attribute.name !== "_feature") {
          //if (attribute.type == "date") {
          defaultAttributes.push({
            dataField: attribute.name,
            type: "string",
            text: attribute.title,
            sort: true,
            searchable: true,
            //filter: textFilter(),
            formatter: function (cell, row) {
              return Editors(
                cell,
                attribute.editor ? attribute.editor : "string",
                false,
                null
              );
            },
          });
          // } else {
          //   defaultAttributes.push({
          //     dataField: attribute.name,
          //     type: "string",
          //     text: attribute.title,
          //     sort: true,
          //     searchable: true,
          //   });
          // }
        }
      }
    });

    return defaultAttributes;
  }

  function dataFormatter(featuresData) {
    let newData = featuresData ? featuresData : [];

    if (featuresData) {
      if (props.layerId) {
        newData.forEach((el) => {
          el._isFavorite =
            favoriteIds.indexOf(el._featureId) >= 0 ? true : false;
        });
      }
    }

    return newData;
  }

  const selectRow = {
    mode: "checkbox",
    onSelect: (data, isSelected) => {
      props.onSelect(data);
    },
    selected: props.selected ? props.selected : [],
    onSelectAll: (isSelected, data, e) => {
      if (props.onSelect) {
        props.onSelect(data);
      }
    },
  };

  return props.data === "pending" ? (
    <Loader></Loader>
  ) : props.withScrollbar ? (
    <>
      {props.savedSearcQuery ? (
        <button
          className="btn btn-sm btn-link border mb-1 me-2"
          onClick={(e) => {
            store.dispatch({
              type: "search/update",
              payload: { id: props.layerId, groups: props.savedSearcQuery },
            });
          }}
        >
          {trans("Search criteria")}
        </button>
      ) : (
        ""
      )}
      {props.withDownloadFeatures ? (
        <button
          className="btn btn-sm btn-link border mb-1 me-2"
          disabled={props.selected?.length > 0 ? false : true}
          onClick={(e) => {
            window["primaryModal"].setState({
              show: true,
              title: "Download features",
              size: "default",
              body: (
                <DownloadFeatures
                  layer={props.layerId}
                  features={props.selected}
                ></DownloadFeatures>
              ),
            });
          }}
        >
          <i className="fas fa-download me-1"></i>
          {trans("Download selected")}{" "}
          {"(".concat(props.selected?.length ? props.selected.length : 0, ")")}
        </button>
      ) : (
        ""
      )}

      {props.withChart ? (
        <button
          className="btn btn-sm btn-link border mb-1 me-2"
          onClick={(e) => {
            window["primaryModal"].setState({
              show: true,
              title: "Features chart",
              size: "xl",
              body: (
                <FeaturesChart
                  layer={props.layerId}
                  features={props.data}
                ></FeaturesChart>
              ),
            });
          }}
        >
          <i className="fas fa-chart-pie me-1"></i> {trans("Chart")}
        </button>
      ) : (
        ""
      )}
      <PerfectScrollbar className="scrollbar-recaclulate">
        <BootstrapTable
          key={key()}
          keyField="_featureId"
          data={dataFormatter(props.data)}
          columns={attributesToBootstrapTableColumns(props.attributes)}
          wrapperClasses="bg-white"
          striped
          hover
          selectRow={selectRow}
          filter={filterFactory()}
        />
      </PerfectScrollbar>
    </>
  ) : (
    <>
      {props.withDownloadFeatures ? (
        <div className="mb-1">
          <button className="btn btn-sm btn-link border">
            {trans("Download selected")}
          </button>
        </div>
      ) : (
        ""
      )}
      <BootstrapTable
        key={key()}
        keyField="_featureId"
        data={dataFormatter(props.data)}
        columns={attributesToBootstrapTableColumns(props.attributes)}
        wrapperClasses="bg-white"
        striped
        hover
        selectRow={selectRow}
        filter={filterFactory()}
      />
    </>
  );
}

export default FeaturesTable;
